import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core"
import { forwardRef } from "react";


export const CloseIcon: React.FC<SvgIconProps> = forwardRef(({...props}, ref) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" innerRef={ref}>
        <rect fill="currentColor" width="2" height="16" transform="translate(14.95 3.636) rotate(45)"/>
        <rect fill="currentColor" width="2" height="16" transform="translate(3.635 5.049) rotate(-45)"/>
    </SvgIcon>
  );
})

export default CloseIcon;